import { Component, Input, OnInit } from '@angular/core'
import { DataCardService } from '../../../../../services/data-card.service'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { HttpErrorResponse } from '@angular/common/http'
import { IDataCardNotification } from '../../../../../models/data-card.model'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-data-card-modal.component.html',
  standalone: false,
})
export class NotificationsDataCardModalComponent implements OnInit {
  @Input() mainObject: string = ''

  private _notifications: IDataCardNotification[] = []
  private _isLoading: boolean = false

  public get notifications(): IDataCardNotification[] {
    return this._notifications
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  public constructor(
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
    public activeModal: NgbActiveModal,
  ) {}

  private getNotifications(): void {
    if (!this.mainObject) {
      return
    }

    this._isLoading = true
    this.dataCardService.getNotificationsByMainObject(this.mainObject).subscribe({
      next: (response: any) => {
        this._notifications = response
        this._isLoading = false
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  public cancel(): void {
    this.activeModal.dismiss()
  }

  public ngOnInit(): void {
    this.getNotifications()
  }
}
